import { createContext } from 'react';
import type { DrillTarget } from './drillTarget';

/** What a screen can do with the panel stack. */
export interface DrillStack {
  open: (target: DrillTarget) => void;
  /** Pops the top panel, putting back whatever was under it. */
  close: () => void;
  /** Empties it — used when leaving for a page, so nothing is left hanging over. */
  closeAll: () => void;
  depth: number;
  /**
   * The panel showing now, if any.
   *
   * Passed through the context rather than as a prop because the state and the
   * thing that draws it are deliberately mounted in two different places: the
   * state above the router so it survives a route change, the host inside it so
   * the links in a panel have a router to resolve against. See DrillHost.
   */
  top: DrillTarget | null;
}

/* Kept out of drill.tsx so its identity survives a hot reload of that file.
   See src/core/i18nContext.ts for what goes wrong otherwise. */
export const DrillContext = createContext<DrillStack | null>(null);
